import { sessionGet } from './tokenUtils';
// import configs from '../configs/configs';

export default ({ getWeChatShareConfig, url, shareText = {} }) => {
  let userAgent = window.navigator.userAgent;
  let urls = "";
  if (userAgent.includes("iPhone") || userAgent.includes("iPad")) {
    // alert(sessionGet("originUrl"));
    urls = sessionGet("originUrl"); //newUrl+'/'
  } else {
    urls = url || window.location.href;
  }

  getWeChatShareConfig({
    shareUrl: urls || window.location.href,
    // mid: mid,
    // appId: window.configs.host.appid,
  }).then((res) => {
    const { code, data, message } = res;
    if (code === "0") {
      //通过微信config接口注入配置
      wx.config({
        debug: false, // 默认为false  为true的时候是调试模式，会打印出日志
        appId: data.appId,
        timestamp: data.timestamp,
        nonceStr: data.nonceStr,
        signature: data.signature,
        jsApiList: [
          "checkJsApi",
          "updateAppMessageShareData",
          "updateTimelineShareData",
          // "onMenuShareAppMessage",
          // "onMenuShareTimeline",
        ],
      });
      //配置自定义分享内容
      // if(share === "cps"){

      // }
      window.share_config = {
        share: {
          imgUrl:
            shareText.imgUrl ? shareText.imgUrl : "https://flnext.oss-cn-hangzhou.aliyuncs.com/picture/6d2ae059ca0d4eaf8cd3ec7d36cdb559.png", // 这里是需要展示的图标
          desc:
            shareText.desc ? shareText.desc : "优酷VIP官方分享售卡平台", // 这是分享展示的摘要
          title: shareText.title ? shareText.title : "酷联盟 | 加入酷联盟", // 这是分享展示卡片的标题
          link: shareText.url ? shareText.url : `${window.location.href}`, // 这里是分享的网址 https://it-ued-tuike-h5.suuyuu.cn
          success: function (rr) {
            console.log('成功' + JSON.stringify(rr))
          },
          cancel: function (tt) {
            console.log('失败' + JSON.stringify(tt));
          },
        },
      };
      wx.ready(function () {
        wx.updateAppMessageShareData(share_config.share); // 微信好友
        wx.updateTimelineShareData(share_config.share); // 微信朋友圈
        // wx.onMenuShareAppMessage(share_config.share);
        // wx.onMenuShareTimeline(share_config.share);
        // wx.hideMenuItems({
        //   menuList: ['menuItem:copyUrl']
        // })
      });
      // wx.error(function (res) {
      //   alert(JSON.stringify(res));  // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      // });
    } else {
      // alert(JSON.stringify(message))
      console.log(message);
    }
  })
  // .catch((error) => {
  //   alert(JSON.stringify(error));
  // })
}